<template>
  <b-modal
    ref="auctionInfoModal"
    id="auctionInfoModal"
    hide-header
    title-class="text-center"
    body-class="p-0"
    :content-class="
      `auctionModal--type-${auction.type} ${colorClass}` +
      (!['PENDING'].includes(auction.status) && auction.leadingBidder && (auction.type === 'LOWEST_UNIQUE' || auction.status === 'ACTIVE') ? ' h-100' : '')
    "
    centered
    scrollable
    @hide="hide()"
    @close="btnSfx"
  >
    <a href="#" class="closeModal" @click="hide()"><img src="/images/player/close.png" /></a>
    <div
      v-if="isMyLeading && auction.paymentStatus === 'WAITING' && !(auction.type === 'LOWEST_UNIQUE' && auction.questionnaireState === 'FAIL')"
      class="auctionItem_winner"
    >
      <img src="/images/home/auctions/icon-wictory.png" />
      <h1>{{ $t('home.auction_item_me_winner_title') }}</h1>
    </div>
    <div v-if="!!auction.id" :class="'auctionItem d-flex p-3 auctionItem--type-' + auction.type">
      <div v-if="auction.type === 'LOWEST_UNIQUE'" class="badge-LOWEST_UNIQUE">
				{{ $t('home.auction_item_badge_lowest_unique') }}
			</div>
			<div v-else-if="auction.maxPrice" class="badge-MAX_BID">
				{{ $t('home.auction_item_max_info') }}
			</div>
      <div class="auctionItem_leftSide">
        <div class="auctionItem_statusBar">
          <div v-if="auction.status != 'FINISHED'">
            <i class="fas fa-clock"></i> {{ lockTime }}
            <span>{{ $t('home.auction_item_timer_title_' + auction.status) }}</span>
          </div>
          <div v-else-if="auction.type === 'LOWEST_UNIQUE' && auction.questionnaireState != 'SUCCESS'">
            {{ $t('home.auction_item_timer_text_lu_' + (auction.questionnaireState === 'FAIL' ? 'FAIL' : auction.leadingBidder != null ? 'WAITING' : 'FAIL')) }}
          </div>
          <div v-else>
            {{ $t('home.auction_item_timer_text_' + (auction.paymentStatus ? auction.paymentStatus : 'NULL')) }}
          </div>
        </div>
        <img :src="auction.photoUrls[viewImage]" />
        <a href="#" @click.prevent="viewImage - 1 >= 0 ? --viewImage : (viewImage = 0)"><i class="fas fa-chevron-circle-left"></i></a>
        <a href="#" @click.prevent="viewImage + 1 < auction.photoUrls.length - 1 ? viewImage++ : (viewImage = auction.photoUrls.length - 1)"
          ><i class="fas fa-chevron-circle-right"></i
        ></a>
      </div>
      <div class="auctionItem_rightSide">
        <h5>{{ auction.name }}</h5>
        <div class="auctionItem_info">
          {{ $t('home.auction_item_label_info') }}
        </div>
        <p>{{ auction.description }}</p>
      </div>
    </div>

    <div v-if="auction.maxPrice" @click="openMaxPriceInfoPopup" class="auctionItem_maxBid">
      <span
        v-html="
          $t('home.auction_item_max_price', {
            max_price: auction.maxPrice.toLocaleString('sr-RS'),
          })
        "
      ></span>
      <img class="diamond" :src="user.mtsCustomer ? '/images/rubins.png' : '/images/diamond.png'" />
    </div>

    <h5 v-if="isMyLeading && auction.status != 'FINISHED'" class="auctionItem_meLeading">
      {{ $t('home.auction_item_me_leading_info') }}
    </h5>

    <div>
      <div v-if="auction.leadingBidder !== undefined" class="auctionItem_highestBidder justify-content-center">
        <h4>
          {{ $t('home.auction_item_label_offer_' + (auction.status === 'FINISHED' ? 'end' : 'current')) }}
        </h4>
        <div class="justify-content-center">
          <img class="profileImage" :src="auction.leadingBidder.avatarUrl !== undefined ? auction.leadingBidder.avatarUrl : '/images/male-default.png'" />
          <b>{{ auction.leadingBidder.username }}</b>
          <template v-if="auction.leadingPrice">
            <b>{{ auction.leadingPrice.toLocaleString('sr-RS') }}</b>
            <img class="diamond" :src="user.mtsCustomer ? '/images/rubins.png' : '/images/diamond.png'" />
          </template>
        </div>
      </div>
      <div v-else-if="auction.type === 'STANDARD'" class="auctionItem_startBid">
        <h4>{{ $t('home.auction_item_label_offer_start') }}</h4>
        <b>{{ auction.startPrice.toLocaleString('sr-RS') }}</b>
        <img class="diamond" :src="user.mtsCustomer ? '/images/rubins.png' : '/images/diamond.png'" />
      </div>
    </div>

    <div v-if="auction.status === 'PENDING'" class="auctionItem_actions text-center p-2">
      <p class="mb-1">
        {{ $t('home.auction_item_bottom_info_panding') }}
      </p>
      <h3 class="font-weight-bold text-danger">
        {{ lockTime }}
      </h3>
    </div>

    <bids-list
      v-if="auction && !['PENDING'].includes(auction.status) && auction.leadingBidder && (auction.type === 'LOWEST_UNIQUE' || auction.status === 'ACTIVE')"
      :auction="auction"
    />

    <div 
      v-if="
        !isMyLeading &&
				auction?.mtsCustomerCategory &&
				!(auction.mtsCustomerCategory?.name === 'ANY' || user.mtsCustomerCategory.id === auction.mtsCustomerCategory.id)
      " 
      class="auctionItem_locked">
      <div class="auctionItem_lockedInfo">
        <i class="fas fa-lock"></i>
        <h6
          v-html="
            $t('home.auction_type_locked', {
              name: auction.mtsCustomerCategory.friendlyName || data.mtsCustomerCategory.name,
            })
          "
        ></h6>
        <a href="https://adbaloo.mobi/loyalty-info/mts">{{ $t('home.more_info_locked') }}</a>
      </div>
    </div>

    <template #modal-footer>
      <b-button
        v-if="auction.status != 'FINISHED' && !isMyLeading"
        @click="
          openBidPopup()
          btnSfx()
        "
        :variant="auction.type === 'LOWEST_UNIQUE' ? 'yellow' : 'primary'"
        size="lg"
        >{{ $t('home.auction_item_btn_bid') }}</b-button
      >
      <b-button
        v-else-if="auction.paymentStatus === 'WAITING' && auction.questionnaireState !== 'FAIL'"
        variant="orange"
        @click="
          hide()
          openRequestPopup()
          btnSfx()
        "
        size="lg"
        >{{ $t('home.auction_item_btn_claim') }}</b-button
      >
      <b-button
        v-else
        variant="primary"
        @click="
          hide()
          btnSfx()
        "
        size="lg"
        >{{ $t('base.btn_ok') }}</b-button
      >
    </template>
  </b-modal>
</template>
<script>
import Vue from 'vue'
import api from '../../api'
import io from '../../socketio'
import BidsList from './BidsList.vue'

const AuctionInfoPopup = Vue.component('auction-info-popup', {
  components: { BidsList },
  data() {
    return {
      lockTime: '',
      auction: {},
      viewImage: 0,
    }
  },

  endDateTimer: null,

  computed: {
    user() {
      return this.$store.state.auth.user
    },

    networkTimeDiff() {
      return this.$store.state.config.networkTimeDiff
    },

    isMyLeading() {
      return !!this.auction.leadingBidder && this.auction.leadingBidder.id === this.user.id
    },

    colorClass() {
      if (this.auction.status === 'FINISHED') {
        if (this.auction.type === 'LOWEST_UNIQUE' && this.auction.questionnaireState != 'SUCCESS') {
          if (this.auction.questionnaireState === 'FAIL' || this.auction.leadingBidder) return 'auction-theme-red'
          else return 'auction-theme-yellow'
        } else if (this.isMyLeading) {
          switch (this.auction.paymentStatus) {
            case 'ERROR':
              return 'auction-theme-red'
            case 'AWARDED':
              return 'auction-theme-green'
            case 'WAITING':
              return 'auction-theme-yellow'
            case 'PROCESSING':
              return 'auction-theme-purple'
            default:
              return 'auction-theme-blue'
          }
        } else {
          return 'auction-theme-blue'
        }
      } else {
        if (this.auction.status === 'PENDING') return 'auction-theme-panding'
        else if (this.auction.type === 'LOWEST_UNIQUE') return 'auction-theme-blue'
        else if (this.auction.maxPrice > 0) return 'auction-theme-max-red'
        else if (this.auction.mtsCustomerCategory) return 'auction-theme-mts'
        else return 'auction-theme-default'
      }
    },
  },

  methods: {
    btnSfx() {
      this.$store.dispatch('sound/sfx', 'Button')
    },

    isAfterNow(time) {
      return time != undefined && moment.utc(time).isAfter(moment.utc() + this.networkTimeDiff)
    },

    clearTimers() {
      if (this.endDateTimer != null) {
        clearInterval(this.endDateTimer)
        this.endDateTimer = null
      }
    },

    openMaxPriceInfoPopup() {
      this.$bvModal
        .msgBoxOk(this.$t('home.auction_max_price_info_popup_text'), {
          title: this.$t('home.auction_max_price_info_popup_title'),
          size: 'sm',
          buttonSize: 'lg',
          okTitle: this.$t('base.btn_ok'),
          modalClass: 'confirmModal',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.$store.dispatch('sound/sfx', 'Button')
        })
    },

    openRequestPopup() {
      const $this = this

      if (this.auction.type === 'LOWEST_UNIQUE' && this.auction?.questionnaireState === 'PENDING')
        this.$bvModal
          .msgBoxConfirm(this.$t('home.auction_lu_question_confirm_popup_text'), {
            title: this.$t('home.auction_lu_question_confirm_popup_title'),
            size: 'sm',
            buttonSize: 'lg',
            okTitle: this.$t('home.auction_lu_question_confirm_popup_start_btn'),
            cancelTitle: this.$t('home.auction_lu_question_confirm_popup_next_time_btn'),
            modalClass: 'confirmModal',
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              $this.$root.$emit('setHomeView', {
                view: 'auction-question',
                target: { ...this.auction },
              })
            }
          })
          .then((value) => {
            $this.$store.dispatch('sound/sfx', 'Button')
          })
      else
        this.$root.$emit('setHomeView', {
          view: 'auction-form',
          target: { ...this.auction },
        })
    },

    show(auction) {
      io.io.on('AUCTION_UPDATE', this.onAuctionUpdate)

      if (auction.id == undefined) {
        this.loadAuction(auction)
      } else {
        this.auction = auction
        this.$refs.auctionInfoModal.show()
      }
    },

    onAuctionUpdate(data) {
      if (!!data.id && data.id === this.auction.id) {
        this.auction = data
      }
    },

    hide() {
      io.io.off('AUCTION_UPDATE', this.onAuctionUpdate)
      this.$refs.auctionInfoModal.hide()
      this.clearTimers()
      this.auction = {}
      this.viewImage = 0
    },

    formatTime(time) {
      if (time < 0) time = 0 // fix negative
      let t = moment.duration(moment.utc(time).diff(moment.utc() + this.networkTimeDiff))

      if (t.asDays() > 1) return t.days() + 'd' + (t.hours() > 0 ? ' ' + this.pad2(t.hours()) + 'h' : '')
      else if (t.hours() > 0) return this.pad2(t.hours()) + ':' + this.pad2(t.minutes()) + 'h'
      else if (t.minutes() > 0) return this.pad2(t.minutes()) + ':' + this.pad2(t.seconds()) + 'm'

      return '00:' + this.pad2(t.seconds()) + 's'
    },

    pad2(number) {
      if (number < 0) number = 0
      return (number < 10 ? '0' : '') + number
    },

    loadAuction(id) {
      const $this = this

      api
        .auctionsInfo(id)
        .then((res) => {
          $this.auction = res.data
          $this.$refs.auctionInfoModal.show()
        })
        .catch((err) => {
          api.baseErrorHendler(err)
        })
    },

    setTimer() {
      const $this = this
      let time = undefined

      this.clearTimers()
      if (!this.auction) return

      // for test only
      // this.auction.endDateTime = "2022-09-08T10:17";

      time = moment.utc(this.auction.status === 'PENDING' ? this.auction.startDateTime : this.auction.endDateTime)

      if (this.isAfterNow(time)) {
        this.lockTime = this.formatTime(time)

        // run timer if limit expiry in one hour
        if (
          moment
            .utc(moment.utc() + $this.networkTimeDiff)
            .subtract(1, 'hours')
            .isBefore(time)
        )
          this.endDateTimer = setInterval(() => {
            let nt = moment.utc() + $this.networkTimeDiff
            if (moment.utc(nt).isBefore(time)) $this.lockTime = $this.formatTime(time)
            else {
              $this.lockTime = undefined
              $this.clearTimers()
            }
          }, 1000)
      }
    },

    openBidPopup() {
      this.$root.$emit('setHomeView', {
        view: 'auction-bid',
        target: this.auction,
      })
    },

    updateFromRequestPopup(data) {
      if (data && data.id == this.auction.id) this.loadAuction(this.auction.id)
    },
  },

  watch: {
    auction() {
      if (this.auction) {
        this.setTimer()
      }
    },
  },

  beforeDestroy() {
    this.clearTimers()
    this.$root.$off('updateAuctionRequest', this.updateFromRequestPopup)
  },

  mounted() {
    this.$root.$on('updateAuctionRequest', this.updateFromRequestPopup)
  },
})

export default AuctionInfoPopup
</script>
